import {salt} from '../constants/hash';

const bcrypt = require('react-native-bcrypt');

// Set cryptographically secure random fallback for web
if (typeof window !== 'undefined' && window.crypto) {
  bcrypt.setRandomFallback((len: number) => {
    const buf = new Uint8Array(len);
    window.crypto.getRandomValues(buf);
    return Array.from(buf);
  });
}

export const hashPassword = (password: string): string => bcrypt.hashSync(password, salt);
